import { render, staticRenderFns } from "./UserSupportBox.vue?vue&type=template&id=56532fd5"
import script from "./UserSupportBox.vue?vue&type=script&lang=js"
export * from "./UserSupportBox.vue?vue&type=script&lang=js"
import style0 from "./UserSupportBox.vue?vue&type=style&index=0&id=56532fd5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports